import React from 'react';
import { Divider } from '@amzn/storm-ui';
import { SideNavGroup } from '@amzn/aac-chrome-internal-api';
import {
  ExpandedListGroupTitle,
  ExpandedListItem,
  ExpandedListWrapper,
} from './styles';
import { renderFlag } from 'src/commons/components/LaunchFlag/LaunchFlag.utils';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';
import {
  NavCohortContext,
  publishNavLinkClick,
} from 'src/features/nav/utils/navLinkClick';

interface MobileSideNavExpandedListProps {
  sidebarGroups: Array<SideNavGroup>;
  sidebarGroupTitle?: string;
}

const ExpandedMenuItemList: React.VFC<MobileSideNavExpandedListProps> = ({
  sidebarGroups,
  sidebarGroupTitle,
}) => {
  const navCohort = React.useContext(NavCohortContext);
  const items = sidebarGroups.map((group, groupIndex) => (
    <React.Fragment key={groupIndex}>
      {groupIndex > 0 && (
        <Divider marginBlockStart="xsmall" marginBlockEnd="xsmall" />
      )}
      {group.title &&
        group.title.length > 0 &&
        group.title !== sidebarGroupTitle && (
          <ExpandedListGroupTitle>{group.title}</ExpandedListGroupTitle>
        )}
      {group.links.map((sideNavLinkProp) => (
        <ExpandedListItem
          key={sideNavLinkProp.id}
          href={sideNavLinkProp.link.url}
          isSelected={sideNavLinkProp.isSelected}
          onClick={() => publishNavLinkClick(sideNavLinkProp.id, navCohort)}
          {...getTaktAttributes(sideNavLinkProp.id, chromeComponents.NAV, {
            url: sideNavLinkProp.link.url,
          })}
          data-ccx-e2e-id={sideNavLinkProp.id}
        >
          {sideNavLinkProp.link.label}
          {renderFlag(sideNavLinkProp, {
            isMobile: true,
          })}
        </ExpandedListItem>
      ))}
    </React.Fragment>
  ));
  return <ExpandedListWrapper>{items}</ExpandedListWrapper>;
};

export default ExpandedMenuItemList;
